/**
 * Tira o acento de um texto **preservando o comprimento**.
 *
 * ## Por que preservar o comprimento é o ponto
 *
 * O menu do `@` grifa o trecho que casou, e o grifo é feito por ÍNDICE: o Fuse devolve
 * `[início, fim]` sobre o texto que ele indexou, e `highlightFuseTitle` recorta o nome
 * ORIGINAL nesses índices. Se a normalização encurtasse o texto, o grifo cairia deslocado —
 * o tipo de defeito que ninguém reporta e todo mundo vê.
 *
 * `normalize('NFD')` decompõe `ã` em `a` + marca combinante; remover só a marca devolve `a`,
 * um caractere onde havia um. Para o alfabeto latino — que é o caso de nome de pessoa em
 * português — a conta fecha, e o teste afirma isso caractere a caractere.
 *
 * ## Por que arquivo próprio
 *
 * `at-menu-config/services/index.ts` é arquivo do upstream: mexer nele custa patch, e todo
 * patch é conflito na próxima atualização (Regra 8.15). O que é NOSSO e puro mora fora dele,
 * e assim também roda nesta estação — sem o `node_modules` do Affine e sem os ~16 minutos de
 * build da Regra 8.7.3.
 *
 * Card 1851768965949294521.
 */
/*
 * ⚠️ A classe é escrita com ESCAPE (`\u0300-\u036f`), nunca com as marcas combinantes
 * literais. Marca combinante no fonte não se enxerga — ela se cola no caractere anterior no
 * editor, no `git diff` e na revisão —, e um intervalo escrito assim é impossível de
 * conferir a olho. É a mesma família da Regra 8.44: escrever o caractere sobre o qual se
 * está falando é como o erro entra.
 */
export function semAcento(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}
